module.exports = __webpack_public_path__ + "img/pg-nodata.fae39ee2.png";